module.exports = __webpack_public_path__ + "static/media/Dika_2.7c70d917.png";